<div class="chart-container card flex space-around">
    <p-chart #chart type="bar" [data]="chartResults" [options]="chartOptions" class="w-half md:w-[60rem]"></p-chart>
    <p-treeTable #dt [value]="treeTableResults" *ngIf="!showDetail">
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of columns" [ngClass]="{'align-right': col.align === 'right'}">
                    {{ col.label }}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr [ttRow]="rowNode">
                <td *ngFor="let col of columns; let index = index"
                [ngClass]="{
                    'description': col.field === 'description' && rowNode.parent !== null, 
                    'apparea_description': col.field === 'apparea_description' && rowNode.parent !== null && rowNode.node.leaf === true,
                    'align-right': col.align === 'right',
                    'object-library': col.field === 'object_library' && rowNode.node.leaf === true}" (click)="showDetailedTable(col.field, rowNode.parent, rowData)">
                    <p-treeTableToggler [rowNode]="rowNode"*ngIf="index == 0 || (index != 0 && col.expandable && rowNode.parent !== null)"></p-treeTableToggler>
                    <ng-container *ngIf="isNumber(rowData[col.field]); else notNumber">
                        {{ rowData[col.field] | number }}
                    </ng-container>
                    <ng-template #notNumber>
                        {{ rowData[col.field] == 0 ? "" : rowData[col.field] }} 
                    </ng-template>
                </td>
            </tr>
        </ng-template>
    </p-treeTable>
    <div style="display:block;width:100%;" *ngIf="showDetail">
        <button pButton id="backButton" (click)="backToSummary()">Back to Summary</button>
        <app-detail-table [data]="detailTableData"></app-detail-table>
    </div>
    <p-progressSpinner *ngIf="showLoader"></p-progressSpinner>
<div >

